module.exports = __webpack_public_path__ + "static/media/experience_new.260e50cd.svg";